import { Controller } from "@hotwired/stimulus"

// Toggles floor/ceiling fields based on decay vs develop direction
export default class extends Controller {
  static targets = [
    "description", "floorHelp", "ceilingHelp",
    "floorField", "ceilingField", "floorWrap", "ceilingWrap", "direction"
  ]

  connect() {
    this.update()
  }

  update() {
    const isDevelop = this.selectedDirection() === "develop"

    if (this.hasDescriptionTarget) {
      this.descriptionTarget.textContent = isDevelop
        ? "Automatically increase this tracker over time (e.g., Heat builds up, a clock advances)."
        : "Automatically decrease this tracker over time (e.g., Food spoils, Coin gets spent)."
    }
    if (this.hasFloorHelpTarget) {
      this.floorHelpTarget.textContent = isDevelop
        ? "Not used when developing upward."
        : "Minimum value decay can reach. Default: 1."
    }
    if (this.hasCeilingHelpTarget) {
      this.ceilingHelpTarget.textContent = isDevelop
        ? "Maximum value develop can reach. Defaults to scale max."
        : "Not used when decaying downward."
    }

    if (this.hasFloorFieldTarget) {
      this.floorFieldTarget.disabled = isDevelop
    }
    if (this.hasFloorWrapTarget) {
      this.floorWrapTarget.style.opacity = isDevelop ? "0.4" : "1"
    }

    if (this.hasCeilingFieldTarget) {
      this.ceilingFieldTarget.disabled = !isDevelop
    }
    if (this.hasCeilingWrapTarget) {
      this.ceilingWrapTarget.style.opacity = !isDevelop ? "0.4" : "1"
    }
  }

  selectedDirection() {
    if (this.hasDirectionTarget) return this.directionTarget.value

    const select = this.element.querySelector('select[name*="decay_direction"]')
    return select?.value || "decay"
  }
}
